import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Button } from '@mui/material';
import brickLime from 'shared/assets/img/brick-lime.png';
import brickGrey from 'shared/assets/img/brick-grey.png';

type Props = {
  variant?: 'text' | 'contained' | 'outlined';
  color?: 'primary' | 'secondary';
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  size?: 'small' | 'medium' | 'large';
  forceRefresh?: boolean;
  width?: string | Record<string, any>;
  label?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};
export const CustomButton:FC<PropsWithChildren<Props>> = ({
  variant = 'contained',
  startIcon,
  endIcon,
  size,
  children,
  forceRefresh,
  width = 'auto',
  label,
  color = 'primary',
  onClick,
  disabled
}) => {
  return (
    <Button
      component={label?"label":null}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      size={size}
      disabled={disabled}
      sx={{
        boxShadow: 'none',
        height: {lg:'80px', xs:'60px'},
        backgroundImage: (color === 'primary' && !disabled) ? `url(${brickLime})` : `url(${brickGrey})`,
        backgroundSize: {lg:'40px', xs:'30px'},
        backgroundColor: 'transparent',
        width: width,
        fontSize: {lg:'30px', md:'20px', xs:'18px'},
        color: (color === 'primary' && !disabled) ? '#171717' : '#f5f5f5',
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
